// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationFeaturesText-cls1_aVY","cls2":"TranslationFeaturesText-cls2_Zak TranslationFeaturesText-cls1_aVY"};